import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody } from 'reactstrap'
import { TaxRegistrationForm } from '../../../components/tax-registration-form'

export function AddTaxRegistrationContent (props) {
  return (
    <Card className='rounded-0 border-0 shadow'>
      <CardBody className='p-2 p-lg-4'>
        <TaxRegistrationForm addTaxReg={true} env={props.env} />
      </CardBody>
    </Card>
  )
}

AddTaxRegistrationContent.propTypes = {
  env: PropTypes.object
}
